import './index-shards-tab-content.style.scss'

class indexShardsTabContentController {

}

export default indexShardsTabContentController;



// WEBPACK FOOTER //
// ./ui/src/components/index-shards-tab-content/index-shards-tab-content.controller.js